import countryCodes from '@constants/countryCodes.js';

const allCountryCodes = Object.values(countryCodes)
  .map(c => c.phone.replace('+', ''))
  .sort((a, b) => b.length - a.length);

export const formatters = {
  string: {
    format: value => value,
    unformat: value => value,
  },
  name: {
    format: value => value.replace(/[^a-zA-Z\s-]/g, '').trim(),
    unformat: value => value,
  },
  email: {
    format: value => value.replace(/\s+/g, '').toLowerCase(),
    unformat: value => value,
  },
  phone: {
    format: value => {
      const cleaned = value.replace(/\D/g, '');
      if (cleaned.length < 4) return cleaned;

      let countryCode = '';
      for (const code of allCountryCodes) {
        if (cleaned.startsWith(code)) {
          countryCode = code;
          break;
        }
      }

      if (countryCode) {
        const localNumber = cleaned.slice(countryCode.length);
        if (localNumber.length >= 6) {
          const areaCode = localNumber.slice(0, 3);
          const middle = localNumber.slice(3, 6);
          const end = localNumber.slice(6);
          return `+${countryCode} (${areaCode}) ${middle}${end ? '-' + end : ''}`;
        }
        return `+${countryCode} ${localNumber}`;
      }

      const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
      if (!match) return cleaned;
      const [, first, second, third] = match;
      if (!second) return first;
      if (!third) return `(${first}) ${second}`;
      return `(${first}) ${second}-${third}`;
    },
    unformat: value => value.replace(/\D/g, ''),
  },
  number: {
    format: value => value.replace(/\D/g, ''),
    unformat: value => value,
  },
  currency: {
    format: value => {
      const cleaned = value.replace(/[^\d.]/g, '');
      const parts = cleaned.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.length > 1
        ? `$${parts[0]}.${parts[1].substr(0, 2)}`
        : `$${parts[0]}`;
    },
    unformat: value => value.replace(/[^\d.]/g, ''),
  },
};

export const validators = {
  name: value => {
    const trimmed = value.trim();
    return trimmed.length >= 1 && /^[a-zA-Z\s-]+$/.test(trimmed);
  },

  required: value => {
    if (value === null || value === undefined) return false;
    return value.toString().trim().length > 0;
  },

  email: value => {
    if (!value || typeof value !== 'string') return false;
    const emailRegex = /^[\w.+-]+@([\w-]+\.)+[\w-]{2,63}$/;
    return emailRegex.test(value.trim());
  },

  phone: (value, countryCode = '+1') => {
    const cleaned = value.replace(/\D/g, '');
    const minLength = countryCode === '+1' ? 10 : 9;
    return cleaned.length >= minLength;
  },

  number: value => /^\d+$/.test(value),

  currency: value => /^\$\d{1,3}(,\d{3})*(\.\d{0,2})?$/.test(value),

  password: value => {
    const rules = {
      uppercase: /[A-Z]/.test(value),
      lowercase: /[a-z]/.test(value),
      number: /\d/.test(value),
      special: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(value),
      length: value.length >= 8,
    };
    return Object.values(rules).every(rule => rule === true);
  },
};

export const validateEmail = validators.email;
